import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import BOMForm from "../../../../components/MainForm/BOMForm";
import SUBBOMForm from "../../../../components/MainForm/SUBBOMForm";
import ParentBomsService from "../../../../services/parentboms.service";
import ChildBomsService from "../../../../services/childboms.service";
import SubBomsService from "../../../../services/subboms.service";
import ItemStepMasService from "../../../../services/itemstepmas.service";

export default function AddBOMInformation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [itemStepMas, setItemStepMas] = useState();

  const getAllItemStepMas = () => {
    setLoading(true);
    ItemStepMasService.getAllItemStepMasters()
      .then((response) => setItemStepMas(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const editItemStepMas = (id, data) => {
    setLoading(true);
    ItemStepMasService.editItemStepMasters(id, data)
      .then((response) => setItemStepMas(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitParentBoms = ({ data }) => {
    setLoading(true);
    ParentBomsService.createParentBoms(data?.Parent)
      .then((response) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        const ChildBoms = {
          Array: data?.Child?.Array.map((item) => ({
            ...item,
            Parent_Bom_Id: response.generatedMaps[0].Id
          }))
        };

        const itemStepMasId = itemStepMas.find(
          ({ Item_Id, Parent_Bom_Id }) =>
            !Parent_Bom_Id && Item_Id === data?.Parent?.Array[0].Item_Parent_Id
        )?.Id;
        if (itemStepMasId) {
          editItemStepMas(itemStepMasId, {
            Parent_Bom_Id: response.generatedMaps[0].Id
          });
        }

        handleSubmitChildBoms(ChildBoms);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitChildBoms = (data) => {
    setLoading(true);
    ChildBomsService.createChildBoms(data)
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate(0);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitSubBoms = ({ data }) => {
    setLoading(true);
    SubBomsService.createSubBoms(data)
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate(0);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => getAllItemStepMas(), []);

  return (
    <>
      <Helmet>
        <title>{`สร้างข้อมูล ${state.type === "Bom" ? "" : "SUB "}BOM`}</title>
        <meta
          name="description"
          content={`Add ${
            state.type === "Bom" ? "" : "SUB"
          }BOM Information Page`}
        />
      </Helmet>

      <Container fluid className="p-3">
        {state.type === "Bom" ? (
          <BOMForm onSubmitCallback={handleSubmitParentBoms} />
        ) : (
          <SUBBOMForm onSubmitCallback={handleSubmitSubBoms} />
        )}
      </Container>
    </>
  );
}
